import React from 'react';
import InputDateTime from "../../../../components/input/input-datetime.jsx";
import SelectComponent from "../../../../components/select/select-component.jsx";
import useFetchOptions from "../hooks/use-fetch-options.js";
import {minMenuHeight} from "../../../../components/reports/report-menu/menu.jsx";

const Filters = ({ setFilters, filters }) => {
    const { sectorOptions } = useFetchOptions();

    return (
        <>
            <div className={`mb-2 ${minMenuHeight}`}>
                <form className={'space-y-4'}>

                    <div>
                        <InputDateTime
                            id="dtStart"
                            label="Data/hora inicial *"
                            selected={filters.dtStart}
                            onChange={(date) => setFilters(prev => ({ ...prev, dtStart: date }))}
                            classNameWrapper={"w-full"}
                            dateFormat="LL"
                        />
                    </div>

                    <div>
                        <InputDateTime
                            id="dtEnd"
                            label="Data/hora final *"
                            selected={filters.dtEnd}
                            onChange={(date) => setFilters(prev => ({ ...prev, dtEnd: date }))}
                            classNameWrapper={"w-full"}
                            dateFormat="LL"
                        />
                    </div>

                    <div>
                        <SelectComponent
                            label='Setor'
                            isMulti={false}
                            wrapValues={true}
                            options={sectorOptions}
                            value={filters.sector}
                            onChange={(value) => setFilters(prev => ({...prev, sector: value}))}
                            instanceId="sector"
                            classNameWrapper={"w-full"}
                        />
                    </div>

                </form>
            </div>
        </>
    );
};

export default Filters;